(function () {
  'use strict';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  var state = { tab: 'driver', cat: 'all', q: '' };

  function webDriverCard(w) {
    return '<div class="ak-dl-card ak-dl-card--dark">' +
      '<div class="ak-dl-card__top"><span class="ak-dl-card__badge">Web</span><span class="ak-dl-card__os">' + esc(w.os) + '</span></div>' +
      '<h3 class="ak-dl-card__title">' + esc(w.title) + '</h3>' +
      '<p class="ak-dl-card__models">' + esc(w.models) + '</p>' +
      '<p class="ak-dl-card__note">' + esc(w.note) + '</p>' +
      '<a href="' + esc(w.href) + '" target="_blank" rel="noopener" class="ak-dl-card__cta' + (w.mons ? ' ak-dl-card__cta--mons' : '') + '">開く' +
      '<svg viewBox="0 0 24 24"><path d="M7 17L17 7M7 7h10v10"></path></svg></a></div>';
  }

  function ctaIcon(kind) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' +
      (kind === 'ZIP' ? 'M12 3v12M7 10l5 5 5-5M5 17v4h14v-4' : 'M7 17L17 7M7 7h10v10') + '"></path></svg>';
  }

  var OS_ICONS = {
    Windows: '<svg viewBox="0 0 16 16"><rect x="1" y="1" width="6.5" height="6.5"></rect><rect x="8.5" y="1" width="6.5" height="6.5"></rect><rect x="1" y="8.5" width="6.5" height="6.5"></rect><rect x="8.5" y="8.5" width="6.5" height="6.5"></rect></svg>',
    Mac: '⌘'
  };

  function osClass(it, link) {
    if (it.tab === 'json' || it.kind !== 'ZIP') return '';
    return link.label === 'Mac' ? ' ak-dl-card__cta--mac' : link.label === 'Windows' ? ' ak-dl-card__cta--win' : '';
  }

  function osIcon(it, link) {
    if (it.tab === 'json' || it.kind !== 'ZIP' || !OS_ICONS[link.label]) return '';
    return '<span class="ak-dl-card__os-icon" aria-hidden="true">' + OS_ICONS[link.label] + '</span>';
  }

  function ctaText(it, link) {
    if (it.tab === 'json') return 'ダウンロード';
    if (it.kind === 'Web') return 'ブラウザで開く';
    if (it.kind === 'ZIP' && link.label === 'Windows') return 'Windows版';
    if (it.kind === 'ZIP' && link.label === 'Mac') return 'Mac版';
    return link.label;
  }

  function itemCard(it) {
    var links = it.downloads
      ? it.downloads
      : [{ label: it.kind === 'Web' ? '開く' : 'ダウンロード', href: it.href }];
    return '<div class="ak-dl-card' + (it.kind === 'Web' ? ' ak-dl-card--web' : '') + '">' +
      '<div class="ak-dl-card__top"><span class="ak-dl-card__kind">' + esc(it.kind) + '</span>' +
      (it.meta ? '<span class="ak-dl-card__meta">' + esc(it.meta) + '</span>' : '') + '</div>' +
      '<h3 class="ak-dl-card__title">' + esc(it.title) + '</h3>' +
      '<p class="ak-dl-card__body">' + esc(it.body) + '</p>' +
      (it.note ? '<p class="ak-dl-card__note">' + esc(it.note) + '</p>' : '') +
      '<div class="ak-dl-card__downloads">' +
      links.map(function (link) {
        return '<a href="' + esc(link.href) + '" target="_blank" rel="noopener" aria-label="' + esc(it.title + ' ' + ctaText(it, link)) + '" class="ak-dl-card__cta ak-dl-card__cta--link' + osClass(it, link) + '">' +
          osIcon(it, link) + esc(ctaText(it, link)) + ctaIcon(it.tab === 'json' ? 'ZIP' : it.kind) + '</a>';
      }).join('') +
      (it.inlineNote ? '<span class="ak-dl-card__inline-note">' + esc(it.inlineNote) + '</span>' : '') +
      '</div></div>';
  }

  function renderTabs(root, d, showManuals) {
    var el = root.querySelector('[data-dl-tabs]');
    if (!el) return;
    var tabs = d.tabs.filter(function (t) { return t.key !== 'manual' || showManuals; });
    el.innerHTML = tabs.map(function (t) {
      return '<button type="button" class="ak-dl-tab' + (t.key === state.tab ? ' is-active' : '') + '" data-dl-tab="' + esc(t.key) + '">' + esc(t.label) + '</button>';
    }).join('');
  }

  function renderCats(root, d) {
    var el = root.querySelector('[data-dl-cats]');
    if (!el) return;
    el.innerHTML = d.cats.map(function (c) {
      return '<button type="button" class="ak-filter-pill' + (c.key === state.cat ? ' is-active' : '') + '" data-dl-cat="' + esc(c.key) + '">' + esc(c.label) + '</button>';
    }).join('');
  }

  function renderList(root, d) {
    var listEl = root.querySelector('[data-dl-list]');
    var emptyEl = root.querySelector('[data-dl-empty]');
    if (!listEl) return;
    var kw = state.q.trim().toLowerCase();
    var items = d.items
      .filter(function (i) { return i.tab === state.tab; })
      .filter(function (i) { return state.cat === 'all' || i.cat === state.cat || (i.alsoCats && i.alsoCats.indexOf(state.cat) !== -1); })
      .filter(function (i) { return !kw || (i.title + ' ' + i.body).toLowerCase().indexOf(kw) !== -1; });
    listEl.innerHTML = items.map(itemCard).join('');
    if (emptyEl) emptyEl.hidden = items.length !== 0;
  }

  function syncUrl() {
    if (!window.history || !history.replaceState) return;
    var params = new URLSearchParams(location.search);
    params.set('tab', state.tab);
    params.set('cat', state.cat);
    history.replaceState(null, '', location.pathname + '?' + params.toString() + location.hash);
  }

  function render(root, d, showManuals) {
    renderTabs(root, d, showManuals);
    renderCats(root, d);
    renderList(root, d);
  }

  function init() {
    var root = document.querySelector('[data-downloads-page]');
    var d = window.AKKO_DOWNLOADS;
    if (!root || !d) return;

    var showManuals = root.getAttribute('data-show-manuals') === 'true';

    var params = new URLSearchParams(location.search);
    var tabParam = params.get('tab');
    var catParam = params.get('cat');
    if (tabParam && d.tabs.some(function (t) { return t.key === tabParam && (t.key !== 'manual' || showManuals); })) {
      state.tab = tabParam;
    }
    if (catParam && d.cats.some(function (c) { return c.key === catParam; })) {
      state.cat = catParam;
    }

    var webGrid = root.querySelector('[data-dl-webdrivers]');
    if (webGrid) webGrid.innerHTML = d.webDrivers.map(webDriverCard).join('');

    render(root, d, showManuals);

    root.addEventListener('click', function (e) {
      var tabBtn = e.target.closest('[data-dl-tab]');
      if (tabBtn) {
        state.tab = tabBtn.getAttribute('data-dl-tab');
        render(root, d, showManuals);
        syncUrl();
        return;
      }
      var catBtn = e.target.closest('[data-dl-cat]');
      if (catBtn) {
        state.cat = catBtn.getAttribute('data-dl-cat');
        render(root, d, showManuals);
        syncUrl();
      }
    });

    var search = root.querySelector('[data-dl-search]');
    if (search) {
      search.addEventListener('input', function () {
        state.q = search.value;
        renderList(root, d);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
